module.exports = __webpack_public_path__ + "static/media/guy3.ff3b280a.png";